import React from 'react';

import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';

interface SectionProps {
  title: string;
  children: React.ReactNode;
}

export const Section: React.FC<SectionProps> = (props: SectionProps): JSX.Element => (
  <FormGroup>
    <Label className="legacy-font-proxima-13 u-small-spacing-bottom">{props.title}</Label>
    {props.children}
  </FormGroup>
);
